export default "__VITE_ASSET__BNKItfBJ__"